(function () {
  function init(scope) {
    if (!scope || scope.dataset.ccUnderlineSearchInit === "1") return;
    scope.dataset.ccUnderlineSearchInit = "1";

    var root = scope.matches("[data-cc-underline-search]")
      ? scope
      : scope.querySelector("[data-cc-underline-search]");
    if (!root) return;

    var form = root.querySelector("form");
    var input = root.querySelector("[data-cc-underline-search-input]");
    var clearBtn = root.querySelector("[data-cc-underline-search-clear]");
    if (!form || !input) return;

    function syncClear() {
      if (!clearBtn) return;
      var has = String(input.value || "").trim() !== "";
      clearBtn.hidden = !has;
    }

    if (clearBtn) {
      clearBtn.addEventListener("click", function () {
        input.value = "";
        syncClear();
        input.focus();
      });
    }

    input.addEventListener("input", syncClear);
    input.addEventListener("keydown", function (e) {
      if (e.key === "Enter" && typeof form.requestSubmit === "function") {
        form.requestSubmit();
      }
    });

    scope.querySelectorAll("[data-cc-underline-search-pill]").forEach(function (pill) {
      pill.addEventListener("mousedown", function (e) {
        e.preventDefault();
        input.value = pill.getAttribute("data-q") || "";
        syncClear();
        input.focus();
      });
    });

    syncClear();
  }

  function boot() {
    document
      .querySelectorAll("[data-cc-underline-search], .cc-home-search-bar-section__inner")
      .forEach(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  document.addEventListener("shopify:section:load", boot);
})();
